export const FormFieldChecks = {
  isNumberWithNoType: (field) => {
    return (
      field.dataType === "NUMBER" &&
      (!field.configuration.hasOwnProperty("numberType") ||
        field.configuration.numberType === "")
    );
  },
  isNumberWithInvertedRanges: (field) => {
    return (
      field.dataType === "NUMBER" &&
      field.configuration.numberType !== "" &&
      field.configuration.hasOwnProperty("numberType") &&
      field.configuration.hasOwnProperty("minValue") &&
      field.configuration.minValue &&
      !isNaN(field.configuration.minValue) &&
      field.configuration.hasOwnProperty("maxValue") &&
      field.configuration.maxValue &&
      !isNaN(field.configuration.maxValue) &&
      parseFloat(field.configuration.minValue) >
        parseFloat(field.configuration.maxValue)
    );
  },
  isTextWithNoCharLimit: (field) => {
    return (
      field.dataType === "TEXT" &&
      (!field.configuration.hasOwnProperty("size") ||
        field.configuration.size === null ||
        field.configuration.size === "")
    );
  },
  isTextWithUnpositiveCharLimit: (field) => {
    return (
      field.dataType === "TEXT" &&
      field.configuration.hasOwnProperty("size") &&
      field.configuration.size !== null &&
      field.configuration.size !== "" &&
      parseInt(field.configuration.size) <= 0
    );
  },
  isTextWithUnnaturalCharLimit: (field) => {
    return (
      field.dataType === "TEXT" &&
      field.configuration.hasOwnProperty("size") &&
      field.configuration.size !== null &&
      field.configuration.size !== "" &&
      Math.floor(parseFloat(field.configuration.size)) !==
        parseFloat(field.configuration.size)
    );
  },
  isTextWithNoRowsLimit: (field) => {
    return (
      field.dataType === "TEXT" &&
      field.configuration.hasOwnProperty("maxRows") &&
      (field.configuration.maxRows === null ||
        field.configuration.maxRows === "")
    );
  },
  isTextWithUnpositiveRowsLimit: (field) => {
    return (
      field.dataType === "TEXT" &&
      field.configuration.hasOwnProperty("maxRows") &&
      field.configuration.maxRows !== null &&
      field.configuration.maxRows !== "" &&
      parseInt(field.configuration.maxRows) <= 0
    );
  },
  isTextWithUnnaturalRowsLimit: (field) => {
    return (
      field.dataType === "TEXT" &&
      field.configuration.hasOwnProperty("maxRows") &&
      field.configuration.maxRows !== null &&
      field.configuration.maxRows !== "" &&
      Math.floor(parseFloat(field.configuration.maxRows)) !==
        parseFloat(field.configuration.maxRows)
    );
  },
  isFileWithNoFileLimit: (field) => {
    return (
      field.dataType === "FILE" &&
      (!field.configuration.hasOwnProperty("maxNumberOfFiles") ||
        field.configuration.maxNumberOfFiles === null ||
        field.configuration.maxNumberOfFiles === "")
    );
  },
  isDictionaryWithoutValues: (field) => {
    if (field.dataType !== "DICTIONARY") return false;
    const dict = field.configuration && field.configuration.dictionary;
    const values = dict && dict.dictionaryValues;
    return !Array.isArray(values) || values.length === 0;
  },
};

// KPO-185: single source of truth for the error messages shown next to a
// misconfigured field in the form builder. Kept as a pure function so it
// can be unit-tested without pulling in the row-control render tree, and
// so both the "block save" list (see AddNewFormPage) and the visible
// per-field message list use the same predicates.
//
// Returns an array of user-facing strings; empty when the field is OK.
export const errorMessagesFor = (field) =>
  [
    FormFieldChecks.isNumberWithNoType(field) && "Brak ustawionego typu liczby",
    FormFieldChecks.isNumberWithInvertedRanges(field) &&
      "Wartość maksymalna jest mniejsza od wartości minimalnej",
    FormFieldChecks.isTextWithNoCharLimit(field) &&
      "Brak ustawionej liczby znaków",
    FormFieldChecks.isTextWithUnpositiveCharLimit(field) &&
      "Liczba znaków musi być dodatnia",
    FormFieldChecks.isTextWithUnnaturalCharLimit(field) &&
      "Liczba znaków musi być liczbą całkowitą",
    FormFieldChecks.isTextWithNoRowsLimit(field) &&
      "Brak ustawionej liczby wierszy",
    FormFieldChecks.isTextWithUnpositiveRowsLimit(field) &&
      "Liczba wierszy musi być dodatnia",
    FormFieldChecks.isTextWithUnnaturalRowsLimit(field) &&
      "Liczba wierszy musi być liczbą całkowitą",
    FormFieldChecks.isFileWithNoFileLimit(field) &&
      "Brak ustawionej maksymalnej liczby plików",
    FormFieldChecks.isDictionaryWithoutValues(field) &&
      "Brak wartości w słowniku",
  ].filter(Boolean);
